(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/numbergames-related/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/modules/numbergames-related/assets/javascripts/utils.js');
"use strict";


const {
  api_calls: apiCalls
} = svs.numbergames.mybets_core_wager;
const {
  campaign: {
    openCampaignApi,
    asyncOpenCampaignApi
  },
  productMapping
} = svs.numbergames;
const logger = svs.numbergames_related.logger;
const {
  format_text: formatText
} = svs.tur.pay.utils;
const Button = svs.ui.ReactButton;
async function getWagerWithRetry(_ref) {
  let {
    id,
    maxAttempts = 10,
    delayMs = 500
  } = _ref;
  let attemptsLeft = maxAttempts;
  while (attemptsLeft--) {
    if (attemptsLeft === maxAttempts - 1) {
      svs.ui.loader.show();
    }
    try {
      return await apiCalls.fetchWager({
        wagerId: id
      });
    } catch (error) {
      if (attemptsLeft <= 0) {
        throw error;
      }
    }
    await new Promise(resolve => {
      setTimeout(resolve, delayMs);
    });
  }
}
const getPrice = _ref2 => {
  let {
    wagers
  } = _ref2;
  return wagers.reduce((total, _ref3) => {
    let {
      value
    } = _ref3;
    return total + parseFloat(value.wager.betAmount || 0);
  }, 0);
};
async function numberOfChances(_ref4) {
  let {
    product,
    wagers
  } = _ref4;
  await asyncOpenCampaignApi.getCampaign(product);
  const chances = wagers.reduce((chances, _ref5) => {
    var _value$wager$wager$be;
    let {
      value
    } = _ref5;
    const bet = (_value$wager$wager$be = value.wager.wager.bets) === null || _value$wager$wager$be === void 0 ? void 0 : _value$wager$wager$be.find(bet => !productMapping.isJoker(bet.productId));
    return chances + openCampaignApi.calculateChances(product, {
      wager: value.wager.wager,
      draw: bet
    });
  }, 0);
  return chances || 0;
}
function getTitle(_ref6) {
  let {
    product,
    isSyndicate,
    wager,
    partialPaymentFailed
  } = _ref6;
  const customer = isSyndicate ? 'Ert' : 'Ditt';
  let productName = productMapping.getProductName(product) || product;
  if (productMapping.isVikinglotto(product) && wager) {
    const hasJoker = wager.wager.bets.some(b => productMapping.isJoker(b.productId));
    if (hasJoker) {
      productName += ' & Joker';
    }
  }
  if (partialPaymentFailed) {
    return "".concat(customer, " ").concat(productName, " \xE4r betalat, men med en justering.");
  }
  return "".concat(customer, " ").concat(productName, " \xE4r betalat. Lycka till!");
}
function getMessages(_ref7) {
  let {
    product,
    price,
    isSyndicate,
    syndicate,
    grassrootsReceivers,
    chances,
    ticketAmount,
    ticketId,
    partialPaymentFailed
  } = _ref7;
  const messages = [];
  const mybetsHomeLink = "".concat(svs.core.urlMapping.get('myBetsHome'), "?grassrootstoasterredirect");
  const isAcChances = chances && productMapping.isLotto(product);
  const isCampaignChances = chances && !productMapping.isLotto(product);
  const formatChances = chances => chances > 1 ? "".concat(chances, " nya chanser") : '1 ny chans';
  const customer = isSyndicate ? 'Ni' : 'Du';
  if (partialPaymentFailed) {
    messages.push(" N\xE5got gick inte att betala och har d\xE4rf\xF6r exkluderats ur ".concat(isSyndicate ? 'ert' : 'ditt', " k\xF6p. ").concat(price ? "Priset justerades till ".concat(price, " kr.") : ''));
  }
  const getMybetsMessage = () => {
    if (isSyndicate) {
      const syndicateLink = "".concat(svs.core.urlMapping.get('playTogetherTeams'), "?syndicateId=").concat(syndicate === null || syndicate === void 0 ? void 0 : syndicate.syndicateId, "&grassrootstoasterredirect");
      return ['Du hittar ditt spel under ', React.createElement('a', {
        href: syndicateLink,
        key: 'syndicate-link'
      }, 'Spela tillsammans'), ' och ', React.createElement('a', {
        href: mybetsHomeLink,
        key: 'mybets-link'
      }, 'Mina spel'), '.'];
    }
    let message = ['Se dina lagda spel ', React.createElement('a', {
      href: mybetsHomeLink,
      key: 'mybets-link'
    }, 'Mina spel')];
    if (chances) {
      message = ['Se dina lagda spel och extrachanser i ', React.createElement('a', {
        href: mybetsHomeLink,
        key: 'mybets-link'
      }, 'Mina spel'), '.'];
    }
    if (ticketAmount > 0) {
      message.push(React.createElement('br', {
        key: 'br1'
      }), ["D\xE4r v\xE4ntar \xE4ven ".concat(ticketAmount === 1 ? 'din' : 'dina', " "), React.createElement('b', {
        key: 'bold'
      }, ticketAmount === 1 ? 'Trisslott' : 'Trisslotter'), ' på dig.']);
    }
    return message;
  };
  messages.push(getMybetsMessage());
  if (ticketAmount > 0 && ticketId) {
    messages.push(React.createElement(React.Fragment, {
      key: 'skrapa-block'
    }, React.createElement('strong', null, "Vill du skrapa ".concat(ticketAmount === 1 ? 'din' : 'en', " Trisslott direkt?")), React.createElement('br', {
      key: 'skrapa-after-br'
    }), React.createElement(Button, {
      onClick: () => {
        svs.utils.url.navigate(svs.core.urlMapping.get('triss_BetDetail').replace(':wagerId', ticketId));
      },
      inverted: productMapping.isKeno(product),
      className: 'margin-top-1'
    }, 'Skrapa direkt')));
  }
  if (isAcChances) {
    messages.push("".concat(customer, " fick ").concat(formatChances(chances), " att vinna p\xE5 Andra Chansen."));
  }
  if (isCampaignChances) {
    messages.push("".concat(customer, " fick ").concat(formatChances(chances), " i ").concat(productMapping.getProductName(product), " kampanj."));
  }
  if (isSyndicate) {
    messages.push('Spelet skapar Gräsrotenpoäng om lagmedlemmar stöder föreningar');
  }
  if (Array.isArray(grassrootsReceivers) && grassrootsReceivers.length && !isSyndicate) {
    messages.push("".concat(formatText.joinWithPunctuation(grassrootsReceivers), " tackar f\xF6r ditt st\xF6d genom Gr\xE4sroten."));
  }
  return messages;
}
const fetchAndSummarizeWagers = async _ref8 => {
  let {
    wagerIds,
    wagers,
    branding,
    ticketAmount,
    ticketId,
    partialPaymentFailed
  } = _ref8;
  let wagerObject = wagers;
  if (!wagerObject) {
    const wagerIdsArray = wagerIds.split(',');
    wagerObject = {};
    wagerIdsArray.forEach(id => {
      wagerObject[id] = null;
    });
  }
  const idsToFetch = Object.keys(wagerObject).filter(id => !wagerObject[id]);
  if (idsToFetch.length) {
    await Promise.all(idsToFetch.map(async id => {
      try {
        const wager = await getWagerWithRetry({
          id,
          maxAttempts: 10,
          delayMs: 500
        });
        if (!wager) {
          throw new Error('Wager is null or undefined');
        }
        wagerObject[id] = wager;
      } catch (error) {
        wagerObject[id] = null;
      }
    }));
  }
  const successfulWagerIds = Object.keys(wagerObject).filter(id => wagerObject[id]);
  let grassrootsReceivers;
  try {
    const userSettingsGrassrootsReceivers = await svs.tur.usersettings.get({
      key: 'receivers'
    });
    grassrootsReceivers = userSettingsGrassrootsReceivers.value;
  } catch (e) {
    logger.warn('Could not get grassroots receivers from tur usersettings', e);
  }
  svs.ui.loader.hide();
  let product = branding;
  let price;
  let chances;
  let isSyndicate = false;
  let syndicate;
  let wager;
  if (successfulWagerIds.length && successfulWagerIds.length === Object.keys(wagerObject).length) {
    wager = wagerObject[successfulWagerIds[0]];
    product = wager.productName;
    isSyndicate = wager.isSyndicate;
    if (isSyndicate) {
      syndicate = {
        syndicateId: wager.properties.syndicateId
      };
    }
    price = getPrice({
      wagers: successfulWagerIds.map(id => ({
        value: {
          wager: wagerObject[id]
        }
      }))
    });
    chances = await numberOfChances({
      product,
      wagers: successfulWagerIds.map(id => ({
        value: {
          wager: wagerObject[id]
        }
      }))
    });
  } else {
    partialPaymentFailed = true;
  }
  const title = getTitle({
    product,
    isSyndicate,
    wager,
    partialPaymentFailed
  });
  const messages = getMessages({
    product,
    price,
    syndicate,
    isSyndicate,
    grassrootsReceivers,
    chances,
    ticketAmount,
    ticketId,
    partialPaymentFailed
  });
  return {
    title,
    messages
  };
};
setGlobal('svs.numbergames_related.utils', {
  fetchAndSummarizeWagers
});

 })(window);